import { useQuery } from '@tanstack/react-query'
import { newBooksKeys } from '@!/Api/queryKeys'
import { getNewBooksApi } from '@!/Api/newBooks'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useNewBooks = (genreTabName, page, perPage) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  return useQuery({
    queryKey: newBooksKeys.filtered(safeSearch, genreTabName, page, perPage),
    queryFn: async () => {
      return await getNewBooksApi(safeSearch, genreTabName, page, perPage)
    },
    keepPreviousData: true,
  })
}
